import React from "react";
export const SmartShelfContext = React.createContext({});
